var toast = {
  msg: '',
  showState: false,
  showTimeout: 0
};
export default {
  data: function data() {
    return toast;
  },
  install: function install(Vue) {
    return Vue.prototype.toast = function (msg) {
      var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2000;
      clearTimeout(toast.showTimeout);
      toast.msg = msg;
      toast.showState = true;
      toast.showTimeout = setTimeout(function () {
        toast.showState = false;
      }, timeout);
    };
  }
};